import { SupplyBasicFeaturePage } from "..";

/** 地接供应商页面。 */
export function GroundsPage() {
  return <SupplyBasicFeaturePage kind="grounds" />;
}
